import { Divider, Empty, Select } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import StepsButtons from "../CommonComponents/StepsButtons";
import FormInput from "../CommonComponents/FormInput";
import FormSelect from "../CommonComponents/FormSelect";
import { ISignatoryActivityProps } from "../IDataCollection";

const SignatoryActivity = (props: ISignatoryActivityProps) => {
  const {
    selectedInvestor,
    advanceStep,
    translations,
    goBackStep,
    onChangeInvestor,
    errors,
    activitySectors,
    lastExcerciseIncomes,
    language,
    positions,
    activityOptions,
  } = props;

  return (
    <div className="investor-step">
      <label className="investor-select">Inversor:</label>
      <Select
        style={{ width: "100%" }}
        placeholder={selectedInvestor?.institutionLong}
        disabled
      />
      <Divider />
      <p className="investor-step-title">
        <QFTitle title={translations?.signatoryActivities} size="extrabig" />
      </p>
      <div>
        {selectedInvestor?.signatories?.length > 0 &&
          selectedInvestor?.signatories.map((signatory: any, index: number) => {
            return (
              <div key={index}>
                <Divider />
                <QFTitle
                  title={
                    <>
                      {translations?.signatory} {signatory?.name}{" "}
                      {signatory?.firstLastName} {signatory?.secondLastName}
                    </>
                  }
                  size="small"
                />
                <div className="investor-step-form-row">
                  <FormSelect
                    options={activityOptions}
                    mandatory
                    field="situation"
                    index={index}
                    arrayField="signatories"
                    optionField="es"
                    onChangeInvestor={onChangeInvestor}
                    optionName={language}
                    value={signatory?.situation}
                    label={translations?.situation}
                    error={errors?.signatories?.[index]?.situation}
                    placeholder={translations?.selectAnOption}
                  />
                  <FormSelect
                    options={activitySectors}
                    mandatory
                    field="activitySector"
                    index={index}
                    arrayField="signatories"
                    optionField="es"
                    onChangeInvestor={onChangeInvestor}
                    optionName={language}
                    value={signatory?.activitySector}
                    label={translations?.activitySector}
                    error={errors?.signatories?.[index]?.activitySector}
                    placeholder={translations?.selectAnOption}
                  />
                  {signatory?.activitySector === "Otro - Especificar" && (
                    <FormInput
                      mandatory
                      field="otherActivitySector"
                      index={index}
                      arrayField="signatories"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(value, field, index, "signatories")
                      }
                      value={signatory?.otherActivitySector}
                      label={translations?.otherActivitySector}
                      error={errors?.signatories?.[index]?.otherActivitySector}
                      placeholder={translations?.completeField}
                    />
                  )}
                  <FormSelect
                    options={lastExcerciseIncomes}
                    mandatory
                    field="lastExcerciseIncome"
                    optionField="es"
                    index={index}
                    arrayField="signatories"
                    onChangeInvestor={onChangeInvestor}
                    optionName={language}
                    value={signatory?.lastExcerciseIncome}
                    label={translations?.lastExcerciseIncome}
                    error={errors?.signatories?.[index]?.lastExcerciseIncome}
                    placeholder={translations?.selectAnOption}
					shouldSort={false}
                  />
                  <FormSelect
                    options={positions}
                    mandatory
                    field="position"
                    optionField="es"
                    index={index}
                    arrayField="signatories"
                    onChangeInvestor={onChangeInvestor}
                    value={signatory?.position}
                    optionName={language}
                    label={translations?.position}
                    error={errors?.signatories?.[index]?.position}
                    placeholder={translations?.selectAnOption}
                  />
                  <FormSelect
                    mandatory
                    field="isPrp"
                    label={translations?.isPrp}
                    index={index}
                    arrayField="beneficialOwners"
                    value={signatory?.isPrp || false}
                    options={[
                      { id: true, name: translations.yes },
                      { id: false, name: "No" },
                    ]}
                    optionField="id"
                    optionName="name"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    placeholder={translations?.selectAnOption}
					tooltip={translations?.prpDisclaimer1}
                  />
                  <FormInput
                    field="prpPosition"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "signatories")
                    }
                    value={signatory?.prpPosition || ""}
                    label={translations.prpPosition}
                    disabled={!signatory?.isPrp}
                    placeholder={translations?.completeField}
					tooltip={translations?.prpDisclaimer2}
                  />
                </div>
              </div>
            );
          })}
        {selectedInvestor?.signatories?.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={translations?.noBeneficialOwners}
          />
        )}
      </div>
      <Divider />
      <StepsButtons
        advanceStep={advanceStep}
        goBackStep={goBackStep}
        steps={3}
        currentStep={2}
        translations={translations}
        nextText={translations?.next}
      />
    </div>
  );
};

export default SignatoryActivity;
